import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-stock-in",
  "use": "icon-stock-in-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stock-in\"><defs><style type=\"text/css\"></style></defs><path d=\"M832 928H320a128 128 0 0 1-128-128v-128h64v128a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64v-576a64 64 0 0 0-64-64H320a64 64 0 0 0-64 64v192H192v-192a128 128 0 0 1 128-128h512a128 128 0 0 1 128 128v576a128 128 0 0 1-128 128zM519.104 404.352a32 32 0 1 1 45.248-45.248l180.992 181.056a30.4 30.4 0 0 1 2.624 6.4 32 32 0 0 1-11.968 61.44h-640a32 32 0 0 1 0-64h562.752z\" fill=\"#d4237a\" p-id=\"2065\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/stock-in.svg
// module id = Ti1L
// module chunks = 118